import { PartyManagerMapper } from './../../../models/party-manager/party-manager-mapper';

import { PartyCharacteristic } from '../../../models/party-manager/party-characteristic';
import { PartySpecification } from '../../../models/party-manager/partySpecifications';
import { map, tap, flatMap, toArray, pluck, mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Party } from 'src/app/models/party-manager/party';
import { AppService } from 'src/app/app.service';

import { Page } from 'src/app/models/search/page';
import { SearchObject } from 'src/app/models/pagination/search-object';
import { Role } from 'src/app/models/party-manager/role';

@Injectable({
  providedIn: 'root'
})
export class PartyService {

  baseUrl:string

  constructor(  private httpClient: HttpClient, private appService: AppService) { 
    this.baseUrl = this.appService.settings.webApi+"/party-manager";
  }



  get(searchObject?: SearchObject):Observable<Page<Party>>{
    let params = new HttpParams();

    if (searchObject) {
      params = params.append('page', searchObject.page.toString());
      params = params.append('size', searchObject.size.toString());
      if(searchObject.sort && searchObject.sort.field && searchObject.sort.direction){
        params = params.append('sortField',searchObject.sort.field);
        params = params.append('sortDirection',searchObject.sort.direction);
      }
    }
    let size:number;
    let numberPage:number;
    let totalElements:number;
   return this.httpClient.get<any>(this.baseUrl + "/parties",{params}).pipe(tap(data =>{
    size = data['size']
    numberPage = data ['number']
    totalElements = data['totalElements']
   }),map((data: any) => data["content"])).pipe(map((partiesApi: any) => {
     
      let parties: Party[] = [];
      for (let partyApi of partiesApi) {
        let specRef = partyApi ['partySpecRef']
        let party :Party= {
           name: partyApi['name'],
           namingId: partyApi['namingId'],
           partySpecRef:{
             namingId:  specRef['namingId'],
             name:  specRef['name'],
             version:  specRef['version']
           },
           domain: partyApi['domain'],
           allowedRoles: PartyManagerMapper.getRoles(partyApi),
           describedByList:PartyManagerMapper.getCharacteristicsFromApi(partyApi)
        };
        parties.push(party);
      }
      return  new Page<Party> (parties,numberPage,size,totalElements);
    }));
  }

  delete(id:string){
    return this.httpClient.delete(`${this.baseUrl}/party/${id}`);
  }

  getSpec():Observable<PartySpecification[]>{
    return this.httpClient.get<any>(this.baseUrl+"/specifications").pipe(map( (data : any) =>data["_embedded"]["partySpecifications"])).pipe(map((partySpecificationsApi:any)=>{
      let partySpecifications:PartySpecification[]= [];
      for(let partySpecificationApi of partySpecificationsApi){
        partySpecifications.push(PartyManagerMapper.getPartySpecificationFromApi(partySpecificationApi))
      }
      return partySpecifications;
    }));
  }

  getCharacteristicBySpec(spec:string):Observable<PartyCharacteristic[]>{
    return this.httpClient.get<any>(this.baseUrl+"/characteristic",{params: {spec:spec}}).pipe(
      pluck('_embedded','partyCharacteristics'),
      map(partyCharacteristicsApi =>{
      let partyCharacteristic :PartyCharacteristic[] = [];
      for(let chatacteristicApi of partyCharacteristicsApi ){
        partyCharacteristic.push(PartyManagerMapper.getPartyCharacteristicFromApi(chatacteristicApi))
      }
      return partyCharacteristic;
    }))
  }

  create(party:Party):Observable<any>{
    return this.httpClient.post<any>(`${this.baseUrl}/party`,party);

  }

  update(party:Party){
    return this.httpClient.patch<any>(`${this.baseUrl}/party/${party.namingId}`,party);
  }


  getPartySimple(specName:string,roleName:string):Observable<Party[]>{

     return this.httpClient.get<any>(`${this.baseUrl}/parties/simple`,{params:{
       specName,
       roleName
     }}).pipe(
      flatMap(x=>x),
      map(data => {return {
        namingId: data['namingId'],
        name: data['name'],
        allowedRoles: null,
        describedByList:null,
        partySpecRef: null,
        domain: null
    } as Party}),
      toArray()
    );
  }

  getCustomers():Observable<Party[]>{
    return this.getPartySimple('ISPParty','CUSTOMER_ISP')
  }

  getProviders():Observable<Party[]>{
    return this.getPartySimple('ISPParty','PROVIDER_ISP')
  }

  getRoles():Observable<Role[]>{
    return this.httpClient.get<any>(`${this.baseUrl}/roles`).pipe(
      pluck('_embedded','partyRoles'),
      mergeMap(x=>x),
      map(item =>{
        let refLink:string[] = item['_links']['self']['href'].split('/');
        return { name: item['name'],id:Number( refLink[refLink.length-1])} as Role;
      }),
      toArray()
    );
  }

  getRolesByParty(idParty:string){
    return this.httpClient.get<any>(`${this.baseUrl}/party/${idParty}/roles`).pipe(
      pluck('_embedded','partyRoles'),
      mergeMap(x=>x),
      map(item =>{
        let refLink:string[] = item['_links']['self']['href'].split('/');
        return { name: item['name'],id: new Number( refLink[refLink.length-1])} as Role;
      }),
      toArray()
    );
  }



}
